import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// actions
import { professionActions } from '../../application/actions/profession';
import { positionActions } from '../../application/actions/position';
import { participationFeesActions } from '../../application/actions/participationFees';
import { officesActions } from '../../application/actions/offices';
import { workActivityActions } from '../../application/actions/workActivity';
import { countryNationalityActions } from '../../application/actions/countryNationality';
import { indicatorsActions } from '../../application/actions/indicators';
import { banksActions } from '../../application/actions/banks';
import { accountsTypesActions } from '../../application/actions/accountsTypes'

// Containers
import PersonalData from '../containers/PersonalData/PersonalData';
import Contracts from '../containers/Contracts/Contracts';
import Summary from '../containers/Summary/Summary';
// components
import Layout from '../components/templates/Layout/Layout';
// utils
import routes from '../../application/config/routes';
// assets
import '../assets/styles/global.css';

const App = () => {
  const appRoutes = routes();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(professionActions.fetchProfessions());
    dispatch(positionActions.fetchPosition());
    dispatch(participationFeesActions.fetchParticipationFees());
    dispatch(officesActions.fetchOffices());
    dispatch(workActivityActions.fetchWorkActivity());
    dispatch(countryNationalityActions.fetchCountryNationality());
    dispatch(indicatorsActions.fetchIndicators());
    dispatch(banksActions.fetchBanks());
    dispatch(accountsTypesActions.fetchAccountsTypes());
  }, []);

  return (
    <>
      <Helmet>
        <title>Cooperativa | Coopeuch</title>
      </Helmet>
      <Router>
        <Layout>
          <Switch>
            <Route path="/" exact>
              <Redirect to={appRoutes.personalData.path} />
            </Route>
            <Route path={appRoutes.personalData.path} exact>
              <PersonalData />
            </Route>
            <Route exact path={appRoutes.contracts.path}>
              <Contracts />
            </Route>
            <Route exact path={appRoutes.summary.path}>
              <Summary />
            </Route>
          </Switch>
        </Layout>
      </Router>
    </>
  );
}

export default App;
